import { ArrowRight, Check, Video, FileText, CalendarCheck, Users, MessagesSquare, Map } from "lucide-react";
import { PAYMENT_URL, DARK_TEXTURE } from "../lib/site";
import { SectionHead, Reveal, CtaButton } from "./Reveal";

const INCLUSIONS = [
  { label: "2 Live Online Sessions", Icon: Video },
  { label: "AI Product Creation Demo", Icon: FileText },
  { label: "Practical Learning Worksheet", Icon: CalendarCheck },
  { label: "7-Day Action Plan", Icon: Map },
  { label: "Live Questions & Answers", Icon: MessagesSquare },
  { label: "Private Bootcamp Community", Icon: Users },
];

export default function Pricing() {
  return (
    <section id="included" data-testid="pricing-section" className="grain relative overflow-hidden bg-[#1C102D] py-20 sm:py-28">
      <img
        src={DARK_TEXTURE}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.07]"
      />
      <div className="drift pointer-events-none absolute -right-24 top-16 h-96 w-96 rounded-full bg-[#9B5CF0]/15 blur-[130px]" />

      <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHead
          dark
          eyebrow="Your Bootcamp Access"
          title={<>Everything You Need to <span className="bg-gradient-to-r from-[#C9B8F5] to-[#9B5CF0] bg-clip-text text-transparent">Get Started.</span></>}
          testId="pricing"
        />

        <div className="mt-14 grid items-center gap-8 lg:grid-cols-2">
          <Reveal delay={0.1}>
            <ul className="grid gap-4 sm:grid-cols-2" data-testid="pricing-inclusions">
              {INCLUSIONS.map((inc, i) => (
                <li
                  key={inc.label}
                  className="flex items-center gap-3.5 rounded-2xl border border-[#39235D] bg-[#24163B]/70 p-4 transition-colors duration-300 hover:border-[#9B5CF0]/50"
                  data-testid={`inclusion-${i}`}
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#7C3AED]/20 text-[#C9B8F5]">
                    <inc.Icon size={18} />
                  </span>
                  <span className="text-sm font-semibold text-white">{inc.label}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.22}>
            <div
              data-testid="pricing-card"
              className="relative overflow-hidden rounded-[2rem] border border-[#9B5CF0]/30 bg-gradient-to-b from-[#24163B] to-[#1C102D] p-8 shadow-[0_40px_80px_-30px_rgba(124,58,237,0.45)] sm:p-10"
            >
              <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-[#7C3AED]/25 blur-3xl" />
              <span className="inline-flex items-center gap-2 rounded-full bg-[#7C3AED]/20 px-4 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#C9B8F5]">
                2-Day AI Bootcamp
              </span>
              <div className="mt-7 flex flex-wrap items-end gap-3">
                <span className="pb-2 text-xl font-semibold text-[#777181] line-through">₹999</span>
                <span className="text-6xl font-extrabold leading-none tracking-tight text-white" data-testid="pricing-price">₹199</span>
                <span className="mb-1.5 rounded-full bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-white">
                  80% OFF
                </span>
              </div>
              <p className="mt-3 text-sm font-semibold text-[#B8B1C8]">
                You save <span className="text-[#C9B8F5]">₹800</span> on one-time registration
              </p>
              <ul className="mt-6 space-y-2.5 border-t border-white/10 pt-6">
                {["One-Time Registration", "Live Training", "Beginner Friendly"].map((t) => (
                  <li key={t} className="flex items-center gap-2.5 text-sm font-medium text-[#D9D2E8]">
                    <Check size={15} strokeWidth={3} className="text-[#9B5CF0]" />
                    {t}
                  </li>
                ))}
              </ul>
              <CtaButton href={PAYMENT_URL} testId="pricing-enroll-btn" dark className="mt-8 w-full">
                Join Now — ₹199 <ArrowRight size={17} strokeWidth={2.5} />
              </CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
